import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';

// props:
// - visible
// - serviceTypeConcept
// - onHide
// - onServiceTypeConceptSaved
function ServiceTypeConceptEditDialog(props) {

  // #region Vars and Consts

  const [isNew, setIsNew] = useState(false);
  const [serviceTypes, setServiceTypes] = useState(false);  
  const [active, setActive] = useState(true);
  const defaultValues = {
    description: "",
    serviceType: null
  };
  const {
    control,
    formState: { errors },
    handleSubmit,
    reset
  } = useForm({ defaultValues });

  // #endregion

  // #region Methods

  const resetForm = () => {
    reset(defaultValues);
    setActive(true);
  };

  const getServiceTypes = () => {
    console.group("Get service types");
    fetch(`${process.env.REACT_APP_API_URL}/serviceType/cmb?generic=false`)
      .then(response => response.json())
      .then(data => {
        console.log("Service types", data.responseObject);
        if (data.responseCode === 'OK') {
          setServiceTypes(data.responseObject);
        } else {
          console.warn('Error getting service types', data);
        }
        console.groupEnd();
      }, (error) => {
        console.error("Error getting service types", error);
        console.groupEnd();
      });
  };  

  const createServiceTypeConcept = (
    serviceTypeId,
    description,
    active
  ) => {
    console.group("Create service type concept");
    fetch(`${process.env.REACT_APP_API_URL}/serviceTypeConcept/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        serviceTypeId,
        description,
        active
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("Service type concept created");
        props.onServiceTypeConceptSaved();
        reset();
      } else {
        console.warn("Error creating service type concept");
      }
      console.groupEnd();
    }, (error) => {
      console.error("Error creating service type concept", error);
      console.groupEnd();
    });
  };

  const updateServiceTypConcept = (
    serviceTypeConceptId,
    serviceTypeId,
    description,
    active) => {
    console.group("Updating service type concept");
    fetch(`${process.env.REACT_APP_API_URL}/serviceTypeConcept/update`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        serviceTypeConceptId,
        serviceTypeId,
        description,
        active
      }),
    }).then(response => response.json()).then(data => {
      if (data.responseCode === 'OK') {
        console.log("Service type concept updated");
        props.onServiceTypeConceptSaved();
        reset();
      } else {
        console.warn("Error updating service type concept");
      }
      console.groupEnd();
    }, (error) => {
      console.error("Error updating service type concept", error);
      console.groupEnd();
    });
  };

  const getFormErrorMessage = (name) => {
    return errors[name] && (
      <small className="p-error">
        {errors[name].message}
      </small>
    )
  };

  // #endregion

  // #region Events

  const onDialogHide = () => {
    if (props.onHide) props.onHide();
  };

  const onFormSubmit = (data) => {
    if (isNew) {
      createServiceTypeConcept(
        data.serviceType.serviceTypeId,
        data.description,
        active
      );
    } else {
      updateServiceTypConcept(
        props.serviceTypeConcept.serviceTypeConceptId,
        data.serviceType.serviceTypeId,
        data.description,
        active);
    }
  };

  useEffect(() => {
    resetForm();
    getServiceTypes();
    if (props.serviceTypeConcept) {
      setIsNew(false);      
      reset(props.serviceTypeConcept);
      setActive(props.serviceTypeConcept.active);
    } else {
      setIsNew(true);
    }
  }, [props.visible, props.serviceTypeConcept]);

  // #endregion

  // #region Templates

  const formTemplate = (
    <>
      <form
        onSubmit={handleSubmit(onFormSubmit)}
        className="p-fluid"
      >
        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="description"
              className={classNames({ 'p-error': errors.description })}
            >
              Descripción
            </label>
            <Controller
              name="description"
              control={control}
              rules={{ required: 'La descripción es requeridaa.' }}
              render={({ field, fieldState }) => (
                <InputText
                  id={field.name}
                  {...field}
                  maxLength={255}
                  autoFocus
                  className={classNames({ 'p-invalid': fieldState.invalid })}                 
                />
              )}               
            />
            {getFormErrorMessage('description')}
          </Col>
        </Row>
        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="serviceType"
              className={classNames({ 'p-error': errors.serviceType })}>
              Tipo de servicio*
            </label>
            <Controller
              name="serviceType"
              control={control}
              rules={{ required: 'El tipo de servicio es requerido.' }}
              render={({ field }) => (
                <Dropdown
                  id={field.name}
                  value={field.value}
                  onChange={(e) => field.onChange(e.value)}
                  options={serviceTypes}
                  optionLabel="description" />
              )} />
            {getFormErrorMessage('serviceType')}
          </Col>
        </Row>        
        <Row>
          <Col className='pt-1'>
            <label
              htmlFor="active"
            >
              Activo
            </label>
            <br></br>
            <InputSwitch checked={active} onChange={(e) => setActive(e.value)} />
          </Col>
        </Row>
        <Button
          type="submit"
          label="Guardar"
          className="p-button-raised p-button-sm mt-4" />
      </form>
    </>
  );

  const dialogTemplate = (
    <>
      <Dialog
        header=""
        visible={props.visible}
        onHide={onDialogHide}
        breakpoints={{ '960px': '75vw' }}
        style={{ width: '50vw' }}>
        <h1>Concepto de Tipo de Servicio</h1>
        {formTemplate}
      </Dialog>
    </>
  );

  // #endregion

  return (
    <>
      <article>
        {dialogTemplate}
      </article>
    </>
  );
}

export default ServiceTypeConceptEditDialog;